var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSun = function SvgSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "#FBFF2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.909A5.91 5.91 0 1 0 12 6.09a5.91 5.91 0 0 0 0 11.819ZM19.273 19.273l-.9-.9m0-12.746.9-.9M4.727 19.273l.9-.9M12 2.982V2m0 20v-.982M2.982 12H2m20 0h-.982M5.628 5.627l-.9-.9",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgSun;